// Polyfills
// import 'es6-promise/auto'
// import 'babel-polyfill'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import VeeValidate from 'vee-validate'
import App from './App'
import store from './store'
import router from './router'
import VuesticPlugin from '@/vuestic-theme/vuestic-plugin'
import './i18n'
import YmapPlugin from 'vue-yandex-maps'
import VueResource from 'vue-resource'
import { Auth } from './services/auth'
import vGallery from 'v-gallery'
import Toast from 'vue-toasted'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import 'vue-search-select/dist/VueSearchSelect.css'
import VueTheMask from 'vue-the-mask'
import Vuetify from 'vuetify'
import 'regenerator-runtime/runtime'
// websockets
import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

library.add(faUserSecret)

Vue.config.ignoredElements = [
  /^openvidu/
]

Vue.use(Vuex)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(vGallery)
Vue.use(VuesticPlugin)
Vue.use(YmapPlugin)
Vue.use(VueResource)
Vue.use(Toast, {
  theme: 'none',
  className: 'vuestic-toast',
  iconPack: 'fontawesome',
  duration: 5000
})
Vue.use(VueTheMask)
Vue.use(Vuetify)

// FILTRO PARA CPF E CNPJ
// DEFINIR TIPO DE FILTRO "F" PARA CPF E "J" PARA CNPJ,
const DocumentPersonBrFilter = {
  install (Vue, options) {
    Vue.filter('CpfCnpjFilter', (documentId, documentType) => {
      documentId = typeof documentId !== 'string' ? documentId.toString() : documentId
      if (documentType == 'J') {
        documentId = documentId.padStart(14, '0')
        documentId = documentId.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
      } else {
        documentId = documentId.padStart(11, '0')
        documentId = documentId.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
      }
      return documentId
    })
  },
}
Vue.use(DocumentPersonBrFilter)

// FILTRO PARA DATA E HORA
const DateBRFilter = {
  install (Vue, options) {
    Vue.filter('DateBRFilter', (data, type) => {
      if (data !== null) {
        if (type === 'Financeiro') {
          let formatDate = data.split(' ')
          return formatDate[0].split('-').reverse().join('/')
        } else {
          let formatDate = data.split(' ')
          if (formatDate.length > 1) {
            if (formatDate[1].length >= 8) {
              let dateTimeZone = formatDate[1].split('.')
              return formatDate[0].split('-').reverse().join('/') + ' ' + dateTimeZone[0]
            } else {
              return formatDate[0].split('-').reverse().join('/') + ' ' + formatDate[1]
            }
          } else {
            return formatDate = data.split('-').reverse().join('/')
          }
        }
      }
    })
  },
}
Vue.use(DateBRFilter)

// NOTE: workaround for VeeValidate + vuetable-2
Vue.use(VeeValidate, { fieldsBagName: 'formFields' })

// INTERCEPTORS
Vue.http.interceptors.push((request, next) => {
  // if (request.url.includes("4443")) {
  //     request.headers.set("Authorization", "Basic " + btoa("OPENVIDUAPP:MY_SECRET"))
  // } else {
  //     request.headers.set('Authorization', 'Bearer ' + window.localStorage['token'])
  //     request.headers.set('Role', window.localStorage['id_role'])
  //     request.headers.set('CFC', window.localStorage['cfc'])
  // }
  request.headers.set('Authorization', 'Bearer ' + window.localStorage['token'])
  request.headers.set('Role', window.localStorage['id_role'])
  request.headers.set('CFC', window.localStorage['cfc'])
  request.headers.set('Accept', 'application/json; charset=UTF-8')

  next()
})

Vue.http.interceptors.push((request, next) => {
  next(response => {
    if (response.status === 401) {
      var autoescola = ''
      if (window.localStorage.schema !== 'public') {
        autoescola = window.localStorage.schema
      }
      return Auth.refreshToken()
        .then((dados) => {
          if (dados.status === 400) {
            store.commit('unauthenticated', autoescola)
          } else {
            window.localStorage['token'] = dados.data.access_token
            window.localStorage['refresh_token'] = dados.data.refresh_token
            return Vue.http(request)
          }
        }).catch(() => {
          store.commit('unauthenticated', autoescola)
        })
    } else {
      store.commit('authenticated')
    }
  })
})
//

router.beforeEach((to, from, next) => {
  store.commit('setLoading', true)
  next()
})

router.afterEach((to, from) => {
  store.commit('setLoading', false)
  if (window.localStorage['token'] && typeof window.Echo === 'undefined') {
    window.Pusher = require('pusher-js')

        window.Echo = new Echo({
            broadcaster: 'pusher',
            key: process.env.VUE_APP_WEBSOCKETS_KEY,
            cluster: process.env.VUE_APPWEBSOCKETS_CLUSTER,
            wsHost: process.env.VUE_APP_WEBSOCKETS_HOST, // "websocket.novocfc.com.br", // não funcionou no .env
            wsPort: 443,
            forceTLS: true, // false para desenvolvimento
            disableStats: true,
            authEndpoint: process.env.VUE_APP_WEBSOCKETS_AUTH, // "http://testeback.novocfc.com.br/api/v1/login/broadcast", // não funcionou no .env
            auth: {
                headers: {
                    Authorization: 'Bearer ' + window.localStorage['token'],
                    Accept: 'application/json',
                },
            },
            enabledTransports: ['wss', 'ws']
        })
    }
})

/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
